import { GLOBAL_ERROR } from "@/common/constant/global-error";
import { AdminQuoteDetailHeader } from "@/components/header/AdminQuoteDetailHeader";
import { PartnerInfoModal } from "@/components/modal/PartnerInfoModal";
import { AdminQuoteDetailOrdererTable } from "@/components/table/admin-quote-detail-orderer-table/AdminQuoteDetailOrdererTable";
import { QuoteItemTable } from "@/components/table/quote-item-table/QuoteItemTable";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body16Regular } from "@/components/typography/Body16Regular";
import { H5 } from "@/components/typography/H5";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { quoteService } from "@/services/quote-service";
import { QuoteDetailDto } from "@/types/dto/quote-detail-dto";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function AdminQuoteDetailPage() {
  const [quoteDetail, setQuoteDetail] = useState<QuoteDetailDto>();
  const { id } = useParams();

  const [isPartnerInfoModalOpen, setIsPartnerInfoModalOpen] = useState(false);
  const openPartnerInfoModal = () => {
    setIsPartnerInfoModalOpen(true);
  };

  const closePartnerInfoModal = () => {
    setIsPartnerInfoModalOpen(false);
  };

  const getQuoteDetail = async () => {
    if (!id) {
      return;
    }

    try {
      const response = await quoteService.getById(Number(id));
      if (!response.ok) {
        return alert(GLOBAL_ERROR);
      }
      setQuoteDetail(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getQuoteDetail();
  }, [id]);

  if (!quoteDetail) {
    return null;
  }

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1392px] h-full items-between justify-start gap-[16px]">
        <AdminQuoteDetailHeader quoteDetail={quoteDetail} />

        <AdminQuoteDetailOrdererTable
          quoteDetail={quoteDetail}
          openPartnerInfoModal={openPartnerInfoModal}
        />

        <div>
          <div className="h-[40px] py-[8px] flex items-center gap-[12px]">
            <H5 className="text-semantic-text-heading">견적 상품 목록</H5>
            <Body14Regular className="text-semantic-text-secondary">
              견적서 발행 당시 할인가입니다.
            </Body14Regular>
          </div>

          <QuoteItemTable quoteDetail={quoteDetail} />
        </div>

        <div className="flex items-center justify-center w-full">
          <Body16Regular className="text-semantic-text-secondary">
            견적 유효기간은 견적 일자로부터 30일이며, 고객사 제안 목적으로
            발행된 견적서는 공식 문서 효력을 가지지 않습니다.
          </Body16Regular>
        </div>
      </div>
      {isPartnerInfoModalOpen && (
        <PartnerInfoModal
          closeModal={closePartnerInfoModal}
          userId={quoteDetail.ordererId}
        />
      )}
    </PageWrapper>
  );
}
